import * as VisuallyHidden from '@radix-ui/react-visually-hidden';
import { forwardRef, type InputHTMLAttributes } from 'react';
import { StyledInput } from '@/components/uielements/forms/styles';
import { Render } from '@/components/uielements/render';

export interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label: string | null;
}

export const Input = forwardRef<HTMLInputElement, Props>((props, ref) => (
  <>
    <Render condition={Boolean(props?.label)}>
      <label htmlFor={props.id}>{props.label}</label>
    </Render>
    <Render condition={Boolean(!props?.label && props?.label !== null)}>
      <VisuallyHidden.Root>
        <label htmlFor={props.id}>{props.label}</label>
      </VisuallyHidden.Root>
    </Render>

    <StyledInput ref={ref} {...props} />
  </>
));

Input.displayName = 'Input';
